import {FileModel} from "./file-model";
import {PdfSize} from "./position";

export interface SignerModel {

    signingProcessId: string;
    fileId: string;
    fileName: string;
    signingType: string;
    multipleSigners: boolean;
    iamsigning?: boolean;
    signers: Signers[];
    signpositions: SignPositions[];
    observers?: any[];
    additionalFiles?: FileModel[]; // base64
    message?: string;
    pdfSize?: PdfSize;
    draft: boolean;
}

export interface Signers {
    email: string;
    fullName: string;
    isCreator: boolean;
}

export interface SignPositions {
    signer: string;
    x: number;
    y: number;
    width?: number;
    height?: number;

    /** Seite (1-basiert), auf der die Position liegt */
    pageNumber?: number;
    /** Anzeigegröße der Seite (CSS-Pixel) beim Drop */
    displayWidth?: number;
    displayHeight?: number;
}

export enum SignatureLevel {
    BASIC = 'basic',
    BASICCERT = 'basiccert',
    EXTENDED = 'extended',
    HIGH = 'high',
    MAX = 'max'
}

export enum SigningStates {
    CREATED = "created",
    STARTED = "started",
    FINISHED = "finished",
    OPEN = "open"
}
